// Module
var code = "<template> <div class=\"account-type-badge\" ess-tooltip.bind=\"accountTypeTooltip\"> <span class=\"account-type-initials\" aria-hidden=\"true\">${accountTypeAbbr}</span> </div> </template> ";
// Exports
module.exports = code;